/**
 * Utility functions for Cloudflare CDN image optimization
 * Adds width parameter to CDN URLs for automatic resizing
 */

/**
 * Optimizes CDN image URL with width parameter for Cloudflare
 * @param {string} imageUrl - The original CDN image URL
 * @param {number} width - Desired width in pixels
 * @returns {string} - Optimized image URL with width parameter
 */
export const optimizeImageUrl = (imageUrl, width = 150) => {
  if (!imageUrl || typeof imageUrl !== 'string') {
    return imageUrl;
  }

  // Replace broken cdn.b4t.com with working direct S3 URL
  if (imageUrl.includes('cdn.b4t.com')) {
    return imageUrl.replace(/https?:\/\/cdn\.b4t\.com/, 'https://adminb4tapp.s3.ap-southeast-2.amazonaws.com');
  }

  return imageUrl;
};

/**
 * Predefined image sizes for different use cases
 */
export const IMAGE_SIZES = {
  THUMBNAIL: 50,      // Small thumbnails in lists
  AVATAR_SMALL: 80,   // Small avatars
  AVATAR_MEDIUM: 150, // Medium avatars (default)
  AVATAR_LARGE: 300,  // Large avatars in detail views
  PROFILE_FULL: 500,  // Full profile pictures
};

/**
 * Get optimized image URL for specific use cases
 * @param {string} imageUrl - The original CDN image URL
 * @param {string} size - Size key from IMAGE_SIZES
 * @returns {string} - Optimized image URL
 */
export const getOptimizedImageUrl = (imageUrl, size = 'AVATAR_MEDIUM') => {
  const width = IMAGE_SIZES[size] || IMAGE_SIZES.AVATAR_MEDIUM;
  return optimizeImageUrl(imageUrl, width);
};